// productDetail API
import ajax from './_ajax';

const api = {};
api.getById = function (id) {
  return ajax.get('/api/Product/GetById?id=' + id);
};
api.getSpecificationAttributeList = function (productId) {
  return ajax.get('/api/Product/GetSpecificationAttributeList?productId=' + productId);
};
api.getRelatedProductList = function (productId) {
  return ajax.get('/api/Product/GetRelatedProductList?productId=' + productId);
};
api.getAdditionalServicesByProductId = function (productId) {
  return ajax.get('/api/ProductAdditionalService/GetAdditionalServicesByProductId?id=' + productId);
};
api.getAttributesByProductId = function (productId) {
  return ajax.get('/api/ProductAttribute/GetAttributesByProductId?id=' + productId);
};
api.changeAttribute = function (modelObj) {
  return ajax.post('/api/Product/ChangeAttribute', modelObj);
};
api.searchSpuProducts = function (obj) {
  return ajax.post('/api/Product/SearchSpuProducts', obj);
};
api.addShoppingCart = function (obj) {
  return ajax.post('/api/ShoppingCart/Add', obj);
};
api.saveWishlist = function (obj) {
  return ajax.post('/api/Wishlist/Save', obj);
};
api.deleteWishlistByProductId = function (obj) {
  return ajax.post('/api/Wishlist/DeleteByProductId', obj);
};
api.getAllCompareProduct = function (obj) {
  return ajax.post('/api/CompareProduct/GetAll', obj);
};
api.getAllBranchAndWarehouses = function () {
  return ajax.get('/api/Warehouse/GetAllBranchAndWarehouses');
};
export default api;



// WEBPACK FOOTER //
// ./src/api/productDetailApi.js